let mathJsModulePromise: Promise<typeof import('mathjs')> | null = null;

export const loadMathJs = () => {
    if (!mathJsModulePromise) {
        mathJsModulePromise = import('mathjs');
    }

    return mathJsModulePromise;
};
